import { SectionLabel } from "./SectionLabel";
import { T } from "@/i18n/T";

export function EditorsNote({ body }: { body: string }) {
  if (!body) return null;
  const paragraphs = body.split(/\n\n+/).filter(Boolean);
  return (
    <section className="mb-16">
      <SectionLabel><T k="auto.editor-s-note-ffa0" /></SectionLabel>
      <div className="max-w-3xl font-display text-lg leading-relaxed text-foreground/90">
        {paragraphs.map((p, i) => (
          <p key={i} className="mb-4">
            {p}
          </p>
        ))}
      </div>
    </section>
  );
}
